import '../theme/index.css'

import Vue from 'vue'
import ElementUI from 'element-ui'

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.config.productionTip = false

export default {
}



// WEBPACK FOOTER //
// ./src/utils/ui.js